import React, { memo, useEffect } from 'react';
import './leftNavigationMenu.scss';
import { Link } from 'react-scroll';
import { tools } from '../../../utils';

const LeftNavigationMenu = ({ data, getCoords, hideOnMobile, top }) => {
  useEffect(() => {
    function onScroll () {
      const scrollPos = window.scrollY;
      const scrollLinks = document.querySelectorAll('.scroll-link');
      scrollLinks.forEach((currLink) => {
        const refElement = document.querySelector(
          `#${currLink.getAttribute('data-href')}`
        );
        if (refElement) {
          const refElementTopPos = getCoords(refElement).top;
          const refElementHeight = refElement.clientHeight;

          if (
            refElementTopPos <= scrollPos + window.innerHeight * 0.4 &&
            refElementTopPos + refElementHeight >
              scrollPos + window.innerHeight * 0.1
          ) {
            scrollLinks.forEach((item) => {
              item.parentNode.classList.remove('active');
            });
            currLink.parentNode.classList.add('active');
          }
        }
      });
    }
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [getCoords]);

  const offsetLink =
    tools.canUseDOM &&
    document &&
    document.getElementById('headLine') &&
    document.getElementById('headLine').offsetHeight
      ? -document.getElementById('headLine').offsetHeight * 2.5
      : 20;

  return (
    <div
      className={`left__menu ${hideOnMobile ? 'hideOnMobile' : ''}`}
      id='left__menu'
      style={{ top: `${top}px` }}
    >
      <div className='leftProgress'>
        {data &&
          data.length &&
          data.map((type, i) => (
            <Link
              spy
              smooth
              duration={1500}
              to={type.type}
              key={i}
              offset={offsetLink}
              className='progress__bar soloists__bar'
            >
              <div
                className={`progress__inner__circle scroll-link ${
                  i === 0 ? 'active' : ''
                }`}
                data-href={type.type}
              />
              <span>{`${type.type
                .split('_')
                .join(' ')
                .replace('pressList', '')}`}</span>
            </Link>
          ))}
      </div>
    </div>
  );
};

export default memo(LeftNavigationMenu);
